import script from "./MonitorManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitorManagement.vue?vue&type=script&setup=true&lang=js"

import "./MonitorManagement.vue?vue&type=style&index=0&id=470f9ae0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470f9ae0"]])

export default __exports__